var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parentlevel"},[_c('div',{staticClass:"downouter",style:({ width: _vm.outerwidth })},[_c('div',{staticClass:"downcore",style:({ width: _vm.corewidth + '%' })},[_c('span',{staticStyle:{"position":"absolute","left":"3vw"}},[_vm._v("1h")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }